const header = document.querySelector('[js-header]')
const bkg = document.querySelector('[js-header-bkg]')

let lastScrollTop = 0

window.addEventListener('scroll', () => {
  const st = window.pageYOffset || document.documentElement.scrollTop

  if (st > header.offsetHeight) {
    header.classList.add('is-sticky')
    bkg.style = ''
  } else {
    header.classList.remove('is-sticky')
  }
  if (st > lastScrollTop) {
    header.classList.remove('is-animated')
  } else if (st < lastScrollTop) {
    header.classList.add('is-animated')

  }
  lastScrollTop = st <= 0 ? 0 : st
}, false)